<template>
    <v-container fluid>
        <v-text-field :placeholder="alts.Label" :label="alts.Label" outlined v-model="textValue"></v-text-field>
    </v-container>
</template>

<script>
export default {
    props: ['qAObject'],
    data() {
        return {
            textValue: '',
            questionObject: {},
            alts: [],
            isMandatory: 0,
            surveyValid: false
        }
    },
    watch: {
        textValue(val) {
            if(val.length > 450) {
                return alert("Du får inte skriva mer än 450 tecken");
            }

            if(this.isMandatory === 1) {
                if(val.length > 0) {
                    this.surveyValid = true;
                } else {
                    this.surveyValid = false;
                }
            } else {
                this.surveyValid = true;
            }

            const answerObj = { 
                id: this.questionObject.SurveyID, // SurveyID
                question: this.questionObject.Topic, //  The actual question
                answer: val, // the answer
                type: 'input', // Type of alternativePicker
                answerId: this.alts.ID, // unique answer id
                questionId: this.alts.QuestionsID, // unique question id
                surveyValid: this.surveyValid,
                isMandatory: this.isMandatory
            };
            this.$store.dispatch('setSurvey', answerObj);
        }
    },
    mounted () {
        this.alts = this.$props.qAObject.alternatives[0];
        this.questionObject = this.$props.qAObject.question;
        this.isMandatory = this.$props.qAObject.question.IsMandatory;
    }
}
</script>

<style>

</style>